import { render, staticRenderFns } from "./SimpleMindMap.vue?vue&type=template&id=2995d2cd&scoped=true&"
import script from "./SimpleMindMap.vue?vue&type=script&lang=js&"
export * from "./SimpleMindMap.vue?vue&type=script&lang=js&"
import style0 from "./SimpleMindMap.vue?vue&type=style&index=0&id=2995d2cd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2995d2cd",
  null
  
)

export default component.exports